import { create } from 'zustand'
import { devtools, subscribeWithSelector } from 'zustand/middleware'
import { immer } from 'zustand/middleware/immer'

import { createWorkspacesActionsSlice, createWorkspacesDataSlice } from './slices'
import type { WorkspacesStore } from './types'

export const useWorkspacesStore = create<WorkspacesStore>()(
  devtools(
    subscribeWithSelector(
      immer((...args) => ({
        ...createWorkspacesDataSlice(...args),
        ...createWorkspacesActionsSlice(...args),
      }))
    ),
    {
      name: 'WorkspacesStore',
      enabled: process.env.NODE_ENV === 'development',
    }
  )
)
